import React, {useEffect, useState, useContext} from "react";
import {useAtom} from 'jotai'
import justcastApi from '../api/justcast';
import {Context as MenuContext} from '../context/MenuContext'
import {ChaptersPlayer} from '../components/Chapters'
import {
  chaptersAtom,
} from '../components/Chapters/chaptersAtom'

const EpisodeChapters = (props) => {
  const id = props.match.params.id;
  const showId = props.match.params.show_id;
  const {setEpisodePageMenu} = useContext(MenuContext);
  const [item, setItem] = useState({});
  const [, setChapters] = useAtom(chaptersAtom)

  useEffect(() => {
    justcastApi.get(`/v1/audioposts/${id}/chapters`)
    .then((res) => {
      const data = res.data;
      setItem(data.audiopost);
      setEpisodePageMenu({
        title: "Chapters",
        currentPageId: "episodes",
        currentTabId: "chapters",
        subtitle: data.audiopost.episode_title,
        subtitle: `${data.show.podcast_title} > ${data.audiopost.episode_title}`,
        showName: data.show.podcast_title,
        showId,
        episodeId: id,
        landingPageUrl: data.show.landing_page_url,
        websiteUrl: data.show.player_page_link,
        rssFeed: data.show.rss_feed,
        passwordProtected: data.show.is_password_protected,
        advancedPrivate: data.show.is_advanced_private_feed,
        isPrivate: data.show.is_private,
        isPrivateShow: data.show.is_private_show,
        skill_podcast_website: data.show.skill_podcast_website
      })

      setChapters(data.chapters)
    })
    .catch((err) => {
      console.log(err)
    })

  },[id, showId])

  if(item.id) {
    return (
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <ChaptersPlayer
                item={item}
                audiopostId={id}
                type="chapters"
              />
            </div>
          </div>
        </div>
      </>
    )
  }

  return null;
}

export default EpisodeChapters;